(function () {
  /** Remember “don’t show on non–home pages” after the user closes the popup (home always ignores this). */
  const STORAGE_KEY_NON_HOME_DISMISSED = 'hackney_welcome_popup_dismissed_non_home';

  function setDismissedNonHome() {
    try {
      localStorage.setItem(STORAGE_KEY_NON_HOME_DISMISSED, '1');
    } catch {
      /* ignore */
    }
  }

  /**
   * @param {string} url
   */
  function isCustomerPostedSuccess(url) {
    try {
      const u = new URL(url, window.location.origin);
      return u.searchParams.get('customer_posted') === 'true';
    } catch {
      return /[?&]customer_posted=true(?:&|#|$)/i.test(url);
    }
  }

  /**
   * @param {string} html
   */
  function htmlIndicatesCustomerPosted(html) {
    return /[?&]customer_posted=true(?:&|#|$)/i.test(html);
  }

  /**
   * @param {string} base
   * @param {string} loc
   */
  function resolveLocationUrl(base, loc) {
    try {
      return new URL(loc, base).href;
    } catch {
      return '';
    }
  }

  /**
   * @param {HTMLDialogElement} dialog
   */
  function showSuccessStep(dialog) {
    const signup = dialog.querySelector('[data-welcome-popup-step="signup"]');
    const success = dialog.querySelector('[data-welcome-popup-step="success"]');
    if (signup instanceof HTMLElement) signup.setAttribute('hidden', '');
    if (success instanceof HTMLElement) success.removeAttribute('hidden');
    dialog.setAttribute('aria-labelledby', 'welcome-popup-success-heading');
    const cta = success?.querySelector('button');
    cta?.focus();
  }

  /**
   * @param {HTMLFormElement} form
   * @param {HTMLDialogElement} dialog
   */
  async function submitNewsletter(form, dialog) {
    const submitBtn = form.querySelector('[data-welcome-popup-submit]');

    submitBtn?.classList.add('is-loading');
    submitBtn?.setAttribute('disabled', 'true');

    try {
      const res = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        redirect: 'manual',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'text/html,application/xhtml+xml',
        },
      });

      const loc = res.headers.get('Location');
      if (loc) {
        const absolute = resolveLocationUrl(form.action, loc);
        if (absolute && isCustomerPostedSuccess(absolute)) {
          showSuccessStep(dialog);
          return;
        }
      }

      let html = await res.text();
      let url = res.url || '';

      if (
        res.status >= 300 &&
        res.status < 400 &&
        loc &&
        !isCustomerPostedSuccess(url) &&
        !htmlIndicatesCustomerPosted(html)
      ) {
        try {
          const followUrl = resolveLocationUrl(form.action, loc);
          if (followUrl) {
            const res2 = await fetch(followUrl, {
              credentials: 'same-origin',
              redirect: 'follow',
              headers: { Accept: 'text/html,application/xhtml+xml' },
            });
            html = await res2.text();
            url = res2.url || '';
            if (isCustomerPostedSuccess(url) || htmlIndicatesCustomerPosted(html)) {
              showSuccessStep(dialog);
              return;
            }
          }
        } catch {
          /* ignore */
        }
      }

      if (isCustomerPostedSuccess(url) || htmlIndicatesCustomerPosted(html)) {
        showSuccessStep(dialog);
      }
    } catch {
      /* stay on signup */
    } finally {
      submitBtn?.classList.remove('is-loading');
      submitBtn?.removeAttribute('disabled');
    }
  }

  function init() {
    const dialog = document.getElementById('welcome-popup-dialog');
    if (!dialog || !(dialog instanceof HTMLDialogElement)) return;

    const query = new URLSearchParams(window.location.search);
    if (query.has('form_key')) return;

    const isHomePage = dialog.dataset.isHome === 'true';

    if (!isHomePage) {
      try {
        if (localStorage.getItem(STORAGE_KEY_NON_HOME_DISMISSED) === '1') return;
      } catch {
        /* ignore */
      }
    }

    const postedFromRedirect = query.get('customer_posted') === 'true';

    if (postedFromRedirect) {
      showSuccessStep(dialog);
    }

    const delayMs = postedFromRedirect
      ? 0
      : Math.max(0, parseInt(dialog.dataset.delayMs || '2000', 10) || 0);

    const open = () => {
      if (!dialog.open) dialog.showModal();
    };

    if (delayMs === 0) {
      requestAnimationFrame(open);
    } else {
      setTimeout(open, delayMs);
    }

    // dialog.addEventListener('close', () => {
    //   dismissForever();
    // });

    dialog.querySelectorAll('[data-welcome-popup-dismiss]').forEach((el) => {
      el.addEventListener('click', () => dialog.close());
    });

    const overlay = dialog.querySelector('[data-welcome-popup-overlay]');
    overlay?.addEventListener('click', (e) => {
      if (e.target === overlay) dialog.close();
    });

    dialog.addEventListener('cancel', (e) => {
      e.preventDefault();
      dialog.close();
    });

    const form = dialog.querySelector('#WelcomePopupForm');
    if (form instanceof HTMLFormElement) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        submitNewsletter(form, dialog);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
